// extracted by mini-css-extract-plugin
export var legendIndicator = "_cg-1";
export var legendRight = "_cg-0";